// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-btn{all:unset;width:60px;height:60px;background-color:#c7094b;border-radius:50%;display:flex;justify-content:center;align-items:center;position:fixed;bottom:90px;right:20px;z-index:1}@media(max-width: 576px){.add-btn{width:48px;height:48px;bottom:96px}}.btn-disabled{background-color:#beb8c6 !important}", ""]);
// Exports
module.exports = exports;
